import { type Enum } from '@webapp/infrastructure/types/Enum'

export const IntercomFeedbackSurveyIds = {
  // Example: RFO_AUTOMATION_ALPHA_FEEDBACK: 12345,
  RFO_AUTOMATION_ALPHA_FEEDBACK: 55285437,
  GUIDED_INTAKE_BETA_FEEDBACK: 66148943,
} as const

export type IntercomFeedbackSurveyIdsEnum = Enum<
  typeof IntercomFeedbackSurveyIds
>
